import { store, router, cart } from './store';
import { setGlobals } from '../constants/globals';

localStorage.removeItem('line_items');
setGlobals(store, router, cart);
